import React from "react";
import { Wrapper } from "./styles";
const Loader = () => {
    return(
        <Wrapper>
<svg viewBox="25 25 50 50">
  <circle r="20" cy="50" cx="50"></circle>
</svg>
        </Wrapper>
    )
}
export default Loader